/**
 * Resuelve a dónde aterriza un usuario recién autenticado, a partir del payload del
 * accessToken.
 *
 * Es ruteo, NO una compuerta de autorización: el control real vive en el backend. Acá solo
 * se decide qué portal corresponde a cada rol, y se devuelve `null` para los roles que no
 * tienen portal en la web (repartidores, que operan desde la app) para que la vista muestre
 * el mensaje correspondiente en lugar de dejar el spinner colgado.
 *
 * @param {{ role?: { type?: string, name?: string } }} userData payload decodificado del accessToken
 * @returns {string|null} ruta destino, o `null` si el rol no tiene portal web
 */
export function resolveLoginDestination(userData) {
  const type = userData?.role?.type;
  const name = userData?.role?.name;

  // Repartidores: su carril es la aplicación móvil.
  if (name === 'delivery' || type === 'commerce_fleet') return null;

  if (type === 'company') return '/home';

  // Perfil de display de sala "Centro de Control Logístico IA": aterriza en su carril
  // kiosko de solo lectura. Debe evaluarse ANTES de la rama genérica `logistic`, si no
  // caería en /admin/dashboard.
  if (type === 'logistic' && name === 'control_tower') return '/control-tower';

  // Landing post-login del equipo interno de la logística = Dashboard.
  if (type === 'logistic') return '/admin/dashboard';

  if (type === 'holding') return '/holding/packages';

  // Superadministrador del sistema: aterriza en SU área, /plataforma, que trae su propio
  // shell y ve a todos los clientes a la vez. El portal de un courier no es su casa; para
  // la operación diaria tiene el enlace "Portal de operación" al pie de su menú lateral.
  if (type === 'system') return '/plataforma';

  return null;
}

export default resolveLoginDestination;
